import React from 'react'
import { SecondaryButton } from '../atoms/buttons/SecondaryButton'
import Typography from '../atoms/Typography'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../atoms/dialog'
import PaymentForm from './PaymentForm'

interface Props {
  onSuccess?: () => void
}

const AddPaymentMethodModal: React.FC<Props> = ({ onSuccess }) => {
  const [opened, setOpened] = React.useState(false)

  const handleSuccess = () => {
    setOpened(false)
    onSuccess?.()
  }

  return (
    <Dialog open={opened} onOpenChange={setOpened}>
      <DialogTrigger asChild>
        <SecondaryButton size="md">
          <Typography variant="base" className="text-light-green-50">
            Add Payment Method
          </Typography>
        </SecondaryButton>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Typography variant="2xl" className="text-light-green-50">
              Add New Card
            </Typography>
          </DialogTitle>
        </DialogHeader>
        <PaymentForm onSuccess={handleSuccess} />
      </DialogContent>
    </Dialog>
  )
}

export default AddPaymentMethodModal
